<div class="profile-banner" [style.background-image]="'url(' + BannerImageUrl + ')'">
</div>
<!-- Profile Image -->
<div class="profile-image-container" style="position: relative;">
    <img class="profile-image"
         [src]="'/img_profile/' + ProfileUserID + '/' + ProfileUserImg"
         alt="User Profile"
         style="position: absolute; bottom: 10px; left: 20px; border-radius: 50%; width: 100px; height: 100px; border: 2px solid white;">

    <!-- Edit Profile Button -->
    <button *ngIf="ProfileUserID==UserID" class="btn btn-outline-dark edit-profile-btn"
            style="position: absolute; bottom: 10px; right: 10px;"
            (click)="openEditProfileModal()">
        Edit Profile
    </button>
</div>

<div class="content-wrapper profile-info" style="display: inline-block;" #profileLink>
    <div class="fw-bold username-link">
        <a [routerLink]="'/' + ProfileUsername" class="profile-link"
           (mouseover)="loadUserProfile($event)"
           (mouseleave)="hideUserProfile()">{{ProfileName}} </a>
        <div style="margin: -5px 0 5px 0">
            <a [routerLink]="'/' + ProfileUsername" class="profile-username-link"
               (mouseover)="loadUserProfile($event)"
               (mouseleave)="hideUserProfile()">&#64;{{ProfileUsername}}  </a>
        </div>
        <div *ngIf="userProfile?.ProfileBio" class="profile-bio">
            {{userProfile?.ProfileBio}}
        </div>
        <div *ngIf="userProfile?.Location || userProfile?.URL || userProfile?.RegistrationDate " class="profile-details">
            <span *ngIf="userProfile?.Location && userProfile?.Location.length > 0" class="ms-auto " style="margin-right:5px;" >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-14j79pv r-1gs4q39">
                    <g>
                        <path d="M12 7c-1.93 0-3.5 1.57-3.5 3.5S10.07 14 12 14s3.5-1.57 3.5-3.5S13.93 7 12 7zm0 5c-.827 0-1.5-.673-1.5-1.5S11.173 9 12 9s1.5.673 1.5 1.5S12.827 12 12 12zm0-10c-4.687 0-8.5 3.813-8.5 8.5 0 5.967 7.621 11.116 7.945 11.332l.555.37.555-.37c.324-.216 7.945-5.365 7.945-11.332C20.5 5.813 16.687 2 12 2zm0 17.77c-1.665-1.241-6.5-5.196-6.5-9.27C5.5 6.916 8.416 4 12 4s6.5 2.916 6.5 6.5c0 4.073-4.835 8.028-6.5 9.27z">
                        </path>
                    </g>
                </svg>
                {{userProfile.Location}}
            </span>
            <span *ngIf="userProfile?.URL && userProfile?.URL.length > 0" class="ms-auto " style="margin-right:5px;" >
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-14j79pv r-1gs4q39">
                    <g>
                        <path d="M18.36 5.64c-1.95-1.96-5.11-1.96-7.07 0L9.88 7.05 8.46 5.64l1.42-1.42c2.73-2.73 7.16-2.73 9.9 0 2.73 2.74 2.73 7.17 0 9.9l-1.42 1.42-1.41-1.42 1.41-1.41c1.96-1.96 1.96-5.12 0-7.07zm-2.12 3.53l-7.07 7.07-1.41-1.41 7.07-7.07 1.41 1.41zm-12.02.71l1.42-1.42 1.41 1.42-1.41 1.41c-1.96 1.96-1.96 5.12 0 7.07 1.95 1.96 5.11 1.96 7.07 0l1.41-1.41 1.42 1.41-1.42 1.42c-2.73 2.73-7.16 2.73-9.9 0-2.73-2.74-2.73-7.17 0-9.9z">
                        </path>
                    </g>
                </svg>
                <a [href]="formatUrl(userProfile.URL)" target="_blank" rel="noopener noreferrer" class="profile-url">
                    {{ userProfile.URL }}
                </a>
            </span>
            <span *ngIf="userProfile?.RegistrationDate && userProfile?.RegistrationDate.length > 0" class="ms-auto">
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-14j79pv r-1gs4q39">
                    <g>
                        <path d="M7 4V3h2v1h6V3h2v1h1.5C19.89 4 21 5.12 21 6.5v12c0 1.38-1.11 2.5-2.5 2.5h-13C4.12 21 3 19.88 3 18.5v-12C3 5.12 4.12 4 5.5 4H7zm0 2H5.5c-.27 0-.5.22-.5.5v12c0 .28.23.5.5.5h13c.28 0 .5-.22.5-.5v-12c0-.28-.22-.5-.5-.5H17v1h-2V6H9v1H7V6zm0 6h2v-2H7v2zm0 4h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm4-4h2v-2h-2v2z">
                        </path>
                    </g>
                </svg>
                Joined {{ userProfile.RegistrationDate | date: 'MMMM yyyy' }}
            </span>
        </div>
        <div class="profile-follow">
            <span class="fw-bold ">{{ userProfile?.FollowingCount }}</span>&nbsp; <span class="profile-follow-gray" style="margin-right:20px;">Following</span>
            <span class="fw-bold">{{ userProfile?.FollowersCount }}</span>&nbsp; <span class="profile-follow-gray">Followers</span>

        </div>

    </div>
</div>
